import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const breadcrumbs: BreadcrumbItem[] = [{ label: '首页', href: '/' }];

  if (pathSegments.length > 0) {
    const nameMap: Record<string, string> = {
      category: '分类',
      article: '文章详情',
      about: '关于我们',
      riman: '日漫',
      guoman: '国漫',
      hanman: '韩漫',
      shaonian: '少年热血',
      xuanhuan: '玄幻奇幻',
      aiqing: '恋爱校园',
      xiju: '搞笑日常',
      xuanyi: '悬疑推理',
      kehuan: '科幻未来',
      zhanji: '战斗冒险',
    };

    pathSegments.forEach((seg, idx) => {
      const href = '/' + pathSegments.slice(0, idx + 1).join('/');
      const isLast = idx === pathSegments.length - 1;
      breadcrumbs.push({
        label: nameMap[seg] || seg,
        href: isLast ? undefined : href,
      });
    });
  }

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.label,
      ...(item.href ? { item: `https://www.51dmw.com${item.href}` } : {}),
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="max-w-[1280px] mx-auto px-4 md:px-6 pt-20 pb-2">
        <ol className="flex flex-wrap items-center gap-1 text-sm">
          {breadcrumbs.map((item, idx) => (
            <li key={idx} className="flex items-center gap-1">
              {idx > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              )}
              {item.href ? (
                <Link
                  to={item.href}
                  className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-800 font-medium whitespace-nowrap">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}